import { render, staticRenderFns } from "./ViewCompanies.vue?vue&type=template&id=c2aed776"
import script from "./ViewCompanies.vue?vue&type=script&lang=js"
export * from "./ViewCompanies.vue?vue&type=script&lang=js"
import style0 from "./ViewCompanies.vue?vue&type=style&index=0&id=c2aed776&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports